import { Component, OnInit } from '@angular/core';
import {HeaderService} from "../../../../../services/header/header.service";
import {environment} from "../../../../../../environments/environment.prod";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-approved-inventaire',
  templateUrl: './approved-inventaire.component.html',
  styleUrls: ['./approved-inventaire.component.scss']
})
export class ApprovedInventaireComponent implements OnInit {

  mode: 'validation' | 'apercu' = 'validation';

  file: string = environment.file_url;
  constructor(private headerService: HeaderService, private router : Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.mode = this.route.snapshot.paramMap.get('mode') as 'validation' | 'apercu';
    this.setHeaderConfig();
   /* this.headerService.setConfig({
      title: 'Inventaire',
      buttons: [
        {
          label: 'Retour',
          action: () => this.retour(),
          type: 'primary'
        },
        {
          label: 'Valider',
          action: () => this.exportData(),
          type: 'primary'
        }
        ,
        {
          label: 'Annuler',
          action: () => this.exportData(),
          type: 'secondary'
        }
      ]
    });*/
  }
  setHeaderConfig(): void {
    if (this.mode === 'validation') {
      this.headerService.setConfig({
        title: 'Inventaire',
        buttons: [
          { label: 'Retour', action: () => this.retour(), type: 'primary' },
          { label: 'Valider', action: () => this.retour(), type: 'primary' },
          { label: 'Annuler', action: () => this.retour(), type: 'secondary' }
        ]
      });
    } else {
      this.headerService.setConfig({
        title: ' Inventaire',
        buttons: [
          { label: 'Mettre à jour', action: () => this.editagain(), type: 'primary' }
        ]
      });
    }
  }
  exportData() {
    console.log('Exporting data...');
  }

  retour() {
    this.router.navigate(['/inventaire']);
  }
  editagain(){
    this.router.navigate(['/inventaire/ajout-inventaire']);
  }

}
